import React from "react";
import { instanceOf } from "prop-types";

import Deal from "../../utilities/Deal";
import DealInformation from "../DealInformation";
import * as S from "./styled";

const DealRow = ({ deal }) => {
  let unitComponent;
  if (deal.listingUrl) {
    unitComponent = (
      <a href={deal.listingUrl} rel="noopener noreferrer" target="_blank">
        {deal.getAddress()}
      </a>
    );
  } else {
    unitComponent = deal.getAddress();
  }

  return (
    <tr>
      <S.UnitCell>{unitComponent}</S.UnitCell>
      <td>
        <S.PriceCell>{deal.getPrice()}</S.PriceCell>
        <S.ShowMobile>
          <DealInformation dealInformation={deal.getInformation()} />
        </S.ShowMobile>
        <S.ShowMobile>{deal.getStatus()}</S.ShowMobile>
      </td>
      <S.HideMobileCell>
        <DealInformation dealInformation={deal.getInformation()} />
      </S.HideMobileCell>
      <S.HideMobileCell>{deal.getStatus()}</S.HideMobileCell>
    </tr>
  );
};

DealRow.propTypes = {
  deal: instanceOf(Deal).isRequired
};

export default DealRow;
